import ApiClient from './ApiClient';

class OperatingProceduresAPI extends ApiClient {
  constructor() {
    super('operating_procedures', { accountScoped: true });
  }
}

export default new OperatingProceduresAPI();
